import React from 'react';

const DownloadFile: React.FC<{ width?: string; height?: string; fill?: string }> = ({
  width = '24px',
  height = '24px',
  fill = '#F1F1F1',
}): React.ReactElement => {
  return (
    <>
      <svg
        width={width}
        height={height}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21 0H21.0041L28 7.15485V32H4V0H19H21ZM19 2H6V30H26V9H19V2ZM25.0506 7H21V2.85709L25.0506 7Z"
          fill={fill}
        />
      </svg>
    </>
  );
};

export default DownloadFile;
